function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }


/* GALLERY SLIDER*/
var button = document.getElementById('gallerySlideForward');

var galleryImg = document.getElementById('gallery-1');
var galleryImgWidth = galleryImg.clientWidth;

function checkifDesktop(){
    if ((getWidth()) >= '1200'){
        var galleryDistance = galleryImgWidth;
    }
    else{
        var galleryDistance = (galleryImgWidth + (getWidth() - galleryImgWidth ));
    }
    return galleryDistance;
}
var galleryDistance = checkifDesktop();
console.log(galleryDistance);

button.onclick = function () {
    var slider = document.getElementById('gallery-slider');
    sideScroll(slider,'right',30, galleryDistance,60);
};

var back = document.getElementById('gallerySlideBack');
back.onclick = function () {
    var slider = document.getElementById('gallery-slider');

    sideScroll(slider,'left',30,galleryDistance,60);
};

function sideScroll(element,direction,speed,distance,step){

    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}



document.getElementById("ccrightlg").innerHTML="&copy " + new Date().getFullYear()+ " MARVEL";
document.getElementById("ccrightmd").innerHTML="&copy " + new Date().getFullYear()+ " MARVEL";